import React, { useState } from "react";
import iconDownload from "../../../../assets/img/interna/download.png";
import { handleDownloadCertificado, urlToShare } from '../../../../helpers/helpers';
import { CertificadoFCursoAdmiNotas } from '../../../../services/CertificadosServices';
import { DescargarListaMaterialesCurso,DescargarListaMaterialesUnidad } from '../../../../services/MaterialService';
import { ObtenerCertificadoPersonaCurso } from '../../../../services/UsuarioService';
import { Tooltip } from "primereact/tooltip";
import useAlumno from "../../../../hooks/useAlumno";
import { useNavigate } from "react-router-dom";
import { PrivateRoutes } from "../../../../routes/routes";
import { toast } from "react-toastify";
import * as constantes from "../../../../constants/constantes.js";

function CardDownloadDesktop({ cursoPersona, curso, Persona, Evaluaciones, calcularPromedioNotasPorUnidad, isButtonDisabledMateriales, 
    setButtonDisabledMateriales, setspinnerMateriales, idCurso, spinnerMateriales, ProgressSpinner, listaUnidades , setspinnerCertificado,spinnerCertificado,
    setspinnerNotas,spinnerNotas}) {
        
    const navigate = useNavigate();
    let classNameStyleOn = "flex align-items-center justify-content-center interna-material-download"
    let classNameStyleOff = "flex align-items-center justify-content-center interna-material-download-apagado"
    const [isButtonDisabledCertificado, setButtonDisabledCertificado] = useState(false);
    const [isButtonDisabledNotas, setButtonDisabledNotas] = useState(false);
    let { configuraciones } = useAlumno();

  const handleDownloadMaterialesCursoold = async () => {
        try {

            let jwt = window.localStorage.getItem("jwt");
            setButtonDisabledMateriales(true);
            setspinnerMateriales(true);
            const data = await DescargarListaMaterialesCurso({ jwt, idCurso });
            const byteCharacters = atob(data);
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            const blob = new Blob([byteArray], { type: "application/octet-stream" });
            const url = URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", curso.nombre + "_Materiales.zip");
            document.body.appendChild(link);
            link.click();
            link.remove();
            URL.revokeObjectURL(url);
            setButtonDisabledMateriales(false);
            setspinnerMateriales(false);
        } catch (error) {
            alert("Error al descargar materiales del curso");
            setButtonDisabledMateriales(false);
            setspinnerMateriales(false);
        }
    };
//Constante que genera el certificado de estudios
    const onDownloadCertificado = async() => {
        
        try{
            navigate("/" + PrivateRoutes.HOME + "/ShareCertificate/Course/" + cursoPersona[0].idCurso,{
                state: {downloading:true}
            });

            const res = await handleDownloadCertificado({
                cursoPersona: cursoPersona[0],
                persona: Persona,
                tipo:"Curso"
            });

            console.log('urlCertificado',res)
            navigate("/" + PrivateRoutes.HOME + "/ShareCertificate/Course/" + cursoPersona[0].idCurso,{
                state: {downloading:false, res}
            });

        }catch(error){
            toast.error(error)
        }
  };

    const handleDownloadMaterialesCurso = async () => {
        for(var i = 0; i < listaUnidades.length; i++){
            try {
                let jwt = window.localStorage.getItem("jwt");
                setButtonDisabledMateriales(true);
                setspinnerMateriales(true);
                const data = await DescargarListaMaterialesUnidad({ jwt, idUnidad: listaUnidades[i].idUnidad });
                const byteCharacters = atob(data);
                const byteNumbers = new Array(byteCharacters.length);
                for (let i = 0; i < byteCharacters.length; i++) {
                    byteNumbers[i] = byteCharacters.charCodeAt(i);
                }
                const byteArray = new Uint8Array(byteNumbers);
                const blob = new Blob([byteArray], { type: "application/octet-stream" });
                const url = URL.createObjectURL(blob);
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", listaUnidades[i].descripcionSEO + "_Materiales.zip");
                document.body.appendChild(link);
                link.click();
                link.remove();
                URL.revokeObjectURL(url);
                setButtonDisabledMateriales(false);
                setspinnerMateriales(false);
            } catch (error) {
                alert("Error al descargar materiales del curso");
                setButtonDisabledMateriales(false);
                setspinnerMateriales(false);
            } 
        }
        
    };

    const handleDownloadNotas = async () => {
        let jwt = window.localStorage.getItem("jwt");
        const currentDate = new Date();
        const formattedDate = `${String(currentDate.getDate()).padStart(2, '0')}_${String(currentDate.getMonth() + 1).padStart(2, '0')}_${String(currentDate.getFullYear()).slice(-2)}`;
        let IdPersonaCurso = cursoPersona[0].idPersonaCurso;
        ObtenerCertificadoPersonaCurso({ jwt, IdPersonaCurso }).then(async (dataCert) => {
            let nombrealumno =
                (Persona.nombres == null ? " " : Persona.nombres.trim()) +
                " " +
                (Persona.primerApellido == null ? " " : Persona.primerApellido.trim()) +
                " " +
                (Persona.segundoApellido == null ? " " : Persona.segundoApellido.trim());
            let nombrecursoprograma = curso.nombre;
            let ubicacion = "Lima";
            let enlace = urlToShare //dataCert.LinkCDN
                ? `${urlToShare}${Persona.primerApellido.trim()}-${formattedDate.trim()}-${"DN_"+dataCert.codigoCertificado.split('-').slice(1, 3).join('-').trim()}.pdf`
                : '';
            const fileName = `${Persona.primerApellido.trim()}-${formattedDate.trim()}-${"DN_"+dataCert.codigoCertificado.split('-').slice(1, 3).join('-').trim()}`;
            const codigo = dataCert.codigoCertificado;
            const enlaceQR = constantes.URL_CERTIFICATE +"/ValidateCertificateQR?codigo="+ dataCert.codigoCertificado + "&tipo=2";
            let promedionotaD = 0;
            var detalle = [];
            for (var j = 0; j < listaUnidades.length; j++) {
                var evaluacionesUnidad = Evaluaciones.filter(
                    (x) => x.idUnidad === listaUnidades[j].idUnidad
                );
                let notas;
                let notaMasAlta = 0;
                if (evaluacionesUnidad.length > 0) {
                    notas = evaluacionesUnidad.map((evaluacion) => evaluacion.nota);
                    notaMasAlta = Math.max(...notas);
                }
                let detalleUnidad = {
                    nombremodulo: listaUnidades[j].descripcion,
                    promedio: notaMasAlta,
                    orden: j + 1,
                };
                promedionotaD = promedionotaD + notaMasAlta;
                detalle.push(detalleUnidad);
            }
            promedionotaD = (promedionotaD / listaUnidades.length).toFixed();
            let promedionota = promedionotaD.toString();
            let jsonData = JSON.stringify({
                nombrealumno,
                nombrecursoprograma,
                ubicacion,
                enlace,
                enlaceQR,
                codigo,
                promedionota,
                detalle,
            });
            const dataCDN = {
                Extension: enlace.split('.').pop(),
                NombreCDN: fileName
            };
            try {
                setspinnerNotas(true);
                setButtonDisabledNotas(true)
                const response = { link: enlace, fileName };
                await CertificadoFCursoAdmiNotas({ jwt, jsonData, dataCDN, response }).then((data) => { });
                setButtonDisabledNotas(false)
                setspinnerNotas(false);

            } catch (error) {
                setspinnerNotas(false);
                alert.error("Error en la función CertificadoFCursoAdmi:", error);
            }
        })
    };



    //esv 16-04-25 Mejora
    const notaMinima = parseFloat(configuraciones?.filter(z => z.codigo === "NOTA_MINIMA_APROB")[0].valor);
    const promedio =  calcularPromedioNotasPorUnidad()
    const habilitarCertificado = Evaluaciones && promedio >= notaMinima && isButtonDisabledCertificado === false;
    const habilitarCurso = Evaluaciones &&  promedio >= notaMinima && isButtonDisabledCertificado === false;
    //end esv 16-04-25

    const dataDownloadContent = [
        {
            id: 1,
            title: "Materiales del curso",

        },
        {
            id: 2,
            title: "Certificado del curso"
        },
        {
            id: 3,
            title: "Detalle de notas"
        }
    ]
    return (        
        <div className="p-fluid formgrid grid progreso-desktop-flex materiales" style={{justifyContent:"space-between"}} >
            {dataDownloadContent.map((item, index) => {
                return (
                    <div
                        
                        className="flex interna-material w-full-progreso mb-2"
                        style={{ marginLeft: "1%" }}
                    >
                        <div className="interna-material-info">
                            <span
                                className="subtitle text-sm"
                                data-v-48f3e599=""
                                style={{ marginTop: "0.5rem !important;" }}
                            >
                                <b>{item.title}</b>
                            </span>
                        </div>

                        {item.id == 1 && (
                            <div
                                className={
                                    /* cursoPersona[0].idEstado != 3 &&
                                        isButtonDisabledMateriales == false
                                        ?  */
                                        classNameStyleOn
                                        //: classNameStyleOff
                                }
                                style={{
                                    width: "77px",
                                    height: "100%",
                                }}
                                onClick={() => {
                                   /*  if (
                                        cursoPersona[0].idEstado != 3 &&
                                        isButtonDisabledMateriales == false
                                    ) { */
                                        handleDownloadMaterialesCurso();
                                    //  }
                                }}
                            >
                                {spinnerMateriales ? (
                                    <ProgressSpinner
                                        style={{ width: "50px", height: "50px" }}
                                    />
                                ) : (
                                    <img
                                        src={iconDownload}
                                        width={"17.5px"}
                                        height={"21px"}
                                    ></img>
                                )}
                            </div>


                        )}
                        
                        {item.id == 2 && (
                            <>
                            <div
                                //esv 16-04-25
                                id="descarga-2"
                                className={
                                        habilitarCertificado 
                                            ? "flex align-items-center justify-content-center interna-material-download"
                                            : "flex align-items-center justify-content-center interna-material-download-apagado"
                                    }
                                style={{
                                    width: "77px",
                                    height: "100%",
                                }}
                                onClick={() => {                                     
                                    if ( habilitarCertificado )                                              
                                        {
                                            onDownloadCertificado();
                                        }                                     
                                }}
                            >
                                 {spinnerCertificado ? (
                                    <ProgressSpinner
                                        style={{ width: "50px", height: "50px" }}
                                    />
                                ) : (
                                    <img src={iconDownload} width={"17.5px"} height={"21px"} ></img>
                                )}
                            </div>

                            {/*esv */}
                            {/* {!habilitarCertificado  && (
                                <Tooltip
                                    target={`#descarga-2`}
                                    content={"Este botón está desactivado porque no alcanzaste la nota mínima aprobatoria."}
                                    className="white-tooltip"
                                />
                            )} */}
                            {/*end esv */}                           
                            
                            </>                            
                        )}

                        {item.id == 3 && (
                            <>
                            
                            <div
                               id="descarga-3"
                                    className={
                                        habilitarCertificado || habilitarCurso
                                            ? "flex align-items-center justify-content-center interna-material-download"
                                            : "flex align-items-center justify-content-center interna-material-download-apagado"
                                    }
                                style={{
                                    width: "77px",
                                    height: "100%",
                                }}
                                onClick={() => {
                                    if ( habilitarCurso )                                    
                                     {
                                        handleDownloadNotas();
                                      }
                                }}
                            >
                                 {spinnerNotas ? (
                                    <ProgressSpinner
                                        style={{ width: "50px", height: "50px" }}
                                    />
                                ) : (
                                    <img src={iconDownload} width={"17.5px"} height={"21px"} />
                                )}
                            </div>                            
                            </>
                        )}

                    </div>
                )
            })}
            {!habilitarCertificado && (
                <Tooltip
                    target="#descarga-2"
                    content="Este botón está desactivado porque no alcanzaste la nota mínima aprobatoria."
                    className="white-tooltip"
                />
            )}
    
            {!habilitarCurso && (
                <Tooltip
                    target="#descarga-3"
                    content="Este botón está desactivado porque no alcanzaste la nota mínima aprobatoria"
                    className="white-tooltip"
                />
            )}

        </div>

    )
}

export default CardDownloadDesktop